import http from '../../../lib/http';

export const FETCH_MENU_HABITUES_START = 'FETCH_MENU_HABITUES_START';
export const FETCH_MENU_HABITUES_ERROR = 'FETCH_MENU_HABITUES_ERROR';
export const FETCH_MENU_HABITUES_SUCCESS = 'FETCH_MENU_HABITUES_SUCCESS';

export const CLEAR_MENU_HABITUES = 'CLEAR_MENU_HABITUES';
export const BACK_TO_MENU_HABITUES = 'BACK_TO_MENU_HABITUES';

export function backToMenuHabitues(habituesPage) {
    return {
        type: BACK_TO_MENU_HABITUES,
        payload: {
            habituesPage: habituesPage
        }
    }
}

export function clearMenuHabitues() {
    return {
        type: CLEAR_MENU_HABITUES
    }
}

export function fetchMenuHabitues(branchId, limit, page) {
    return {
        type: 'FETCH_MENU_HABITUES',
        payload: {
            promise: getMenuHabitues(branchId, limit, page)
        }
    };
}

async function getMenuHabitues(branchId, limit, page) {
    const res = await http.get(`/app/bills/habitue-debts/${branchId}/${limit}/${page}`);
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/menu/credit/habitues/actions.js